import React, {PureComponent} from 'react';
import {Collapse, Icon} from "antd";
import Tag from '../Tag';
import styled, {keyframes} from 'styled-components';
import {GreenButton, TransparentButton} from '../Button'

const Panel = styled(Collapse.Panel)`
    background: #fff;
    border-radius: 4px;
    border: 0;
    overflow: hidden;
`;

const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const Header = styled.span`
    color: #4B4B4B; 
`;

const opacity = keyframes`
  0% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 0; }
`;

const SavedLabel = styled.span`
    color: #00C745;
    opacity: 1;
    animation: ${opacity} 4s ;
    margin-right: 10px;
`;

class FilterCollapsePanel extends PureComponent {

    labelAppliedTimeoutId = 0;

    constructor(props) {
        super(props);

        this.state = {
            showLabelApplied: false,
        };
    }

    handleChange = (sectionValue, handleChange) => (checked, value) => {
        if (typeof handleChange === 'function') {
            return handleChange(checked, value, sectionValue);
        }
        return this.props.handleChangeTag(checked, value, sectionValue);
    };

    toggleTags = () => {
        this.props.sections
            .forEach(section => section.data.forEach(tag => {
                this.handleChange(section.value, tag.handleChange)(!this.isAllTagsChecked(), tag.value)
            }));
    };

    getTags = () => this.props.sections.flatMap(section => section.data);

    isAllTagsChecked = () => this.getTags().every(tag => tag.checked);

    canApply = () => this.getTags().some(tag => tag.checked);

    handleApplyClick = () => {
        this.setState({
            showLabelApplied: true
        }, () => {
            this.props.onApplyClick();
            if (this.labelAppliedTimeoutId) {
                clearTimeout(this.labelAppliedTimeoutId);
            }
            this.labelAppliedTimeoutId = setTimeout(() => this.setState({showLabelApplied: false}), 3000);
        });
    }

    renderTags = () => {
        return this.props.sections.map(section => (
            <React.Fragment>
                {
                    section.title && <div style={{ marginBottom: 10, marginLeft: 2 }}>
                        <span style={{ color: '#969696' }}>{section.title}</span>
                    </div>
                }
                {section.data.map(tag =>
                    <Tag
                        value={tag.value}
                        checked={tag.checked}
                        handleChange={this.handleChange(section.value, tag.handleChange)}>{tag.name}</Tag>)}
            </React.Fragment>
        ))
    };

    renderButtons = () => {
        return <React.Fragment>
            <TransparentButton
                onClick={this.toggleTags}
            >
                <Icon type="check" style={{ color: '#4B4B4B', marginRight: 5 }} />
                {this.isAllTagsChecked() ? 'Desmarcar todos' : 'Marcar todos'}
            </TransparentButton>
            <GreenButton
                disabled={!this.canApply()}
                style={{padding: '4px 14px', fontWeight: 'normal', borderRadius: 3}}
                onClick={this.handleApplyClick}>
                Aplicar
            </GreenButton>
        </React.Fragment>
    };

    render() {

        const {showLabelApplied} = this.state;

        return (
            <div>
                <Collapse
                    bordered={false}
                    defaultActiveKey={["1"]}
                    expandIcon={({ isActive }) =>
                        isActive ? (
                            <Icon type="minus-circle" style={{ fontSize: 20, color: '#969696' }} />
                        ) : (
                                <Icon type="plus-circle" style={{ fontSize: 20, color: '#969696' }} />
                            )
                    }
                    expandIconPosition="right"
                >
                    <Panel
                        header={
                        <HeaderContainer>
                            <Header>
                                <Icon type="filter" style={{ color: '#4B4B4B', marginRight: 5}}/>
                                Filtre suas conversas</Header>
                            { showLabelApplied && <SavedLabel>Salvo!</SavedLabel>}
                        </HeaderContainer>
                    } key="1">
                            {this.renderTags()}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            marginTop: 10 }}>
                            {this.renderButtons()}
                        </div>
                    </Panel>
                </Collapse>
            </div>
        )
    }
}

export default FilterCollapsePanel;




// WEBPACK FOOTER //
// ./src/components/FilterCollapsePanel/FilterCollapsePanel.js